import { useNavigate } from "react-router-dom";
import { ArrowRight, Shield, Clock, Award } from "lucide-react";
import { Button } from "./ui/button";
import { heroData } from "../data/mock";

export const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section
      id="home"
      className="relative min-h-[90vh] flex items-center overflow-hidden"
    >
      {/* Background Image + Overlay */}
      <div className="absolute inset-0">
        <img
          src={heroData.backgroundImage}
          alt="Industrial automation background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a2a43]/95 via-[#0a2a43]/80 to-[#0a2a43]/50" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a2a43] via-transparent to-transparent opacity-60" />
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-20 right-10 w-72 h-72 bg-[#ff9900]/10 rounded-full blur-3xl" />
      <div className="absolute bottom-20 left-10 w-56 h-56 bg-[#ff9900]/5 rounded-full blur-3xl" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 lg:py-40">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-8">
            <div className="w-2 h-2 rounded-full bg-[#ff9900] animate-pulse" />
            <span className="text-white/90 text-sm font-medium">Trusted Since 1997</span>
          </div>

          {/* Heading */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            {heroData.heading.split("&").map((part, i) => (
              <span key={i}>
                {i > 0 && <span className="text-[#ff9900]">&</span>}
                {part}
              </span>
            ))}
          </h1>

          {/* Subheading */}
          <p className="text-lg sm:text-xl text-white/70 leading-relaxed mb-10 max-w-2xl">
            {heroData.subheading}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4">
            <Button
              onClick={() => navigate(heroData.ctaLink)}
              className="bg-[#ff9900] hover:bg-[#e68a00] text-white font-semibold px-8 py-6 text-base rounded-xl shadow-lg shadow-[#ff9900]/25 hover:shadow-xl hover:shadow-[#ff9900]/35 transition-all duration-300 hover:-translate-y-0.5"
            >
              {heroData.ctaText}
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
            <Button
              onClick={() => {
                const el = document.getElementById("contact");
                if (el) el.scrollIntoView({ behavior: "smooth" });
              }}
              variant="outline"
              className="border-white/30 text-white hover:bg-white/10 hover:text-white font-semibold px-8 py-6 text-base rounded-xl backdrop-blur-sm transition-all duration-300"
            >
              Get In Touch
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap gap-8 mt-14">
            {[
              { Icon: Shield, text: "CPRI Certified" },
              { Icon: Clock, text: "25+ Years" },
              { Icon: Award, text: "5000+ Installations" },
            ].map(({ Icon, text }) => (
              <div key={text} className="flex items-center gap-2.5">
                <div className="w-10 h-10 rounded-lg bg-white/10 backdrop-blur-sm flex items-center justify-center">
                  <Icon className="w-5 h-5 text-[#ff9900]" />
                </div>
                <span className="text-white/80 text-sm font-medium">{text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
